import { render, staticRenderFns } from "./GiftBoxEntreprise.vue?vue&type=template&id=77fe31a7&scoped=true&"
import script from "./GiftBoxEntreprise.vue?vue&type=script&lang=js&"
export * from "./GiftBoxEntreprise.vue?vue&type=script&lang=js&"
import style0 from "./GiftBoxEntreprise.vue?vue&type=style&index=0&id=77fe31a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe31a7",
  null
  
)

export default component.exports